var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.label
    ? _c("div", { staticClass: "promotion-label" }, [
        _c("span", { class: _vm.labelClass }, [_vm._v(_vm._s(_vm.label))]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }